import { render, staticRenderFns } from "./locais-list-menu.vue?vue&type=template&id=b0b07ecc"
import script from "./locais-list-menu.vue?vue&type=script&lang=js"
export * from "./locais-list-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports